import * as React from "react";
import type { SVGProps } from "react";
export const SvgDownloadWindows = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="m2.5 4.566 6.148-.847v5.94H2.5V4.565Zm0 10.868 6.148.848v-5.867H2.5v5.02Zm6.823.938L17.5 17.5v-7.085H9.323v5.957Zm0-12.744v6.03H17.5V2.5L9.323 3.628Z"
    />
  </svg>
);
